module.exports = __webpack_public_path__ + "img/26.427bea45.png";